import { render, staticRenderFns } from "./application_builder_basic_layout.vue?vue&type=template&id=e61fc83a&scoped=true"
import script from "./application_builder_basic_layout.vue?vue&type=script&lang=js"
export * from "./application_builder_basic_layout.vue?vue&type=script&lang=js"
import style0 from "./application_builder_basic_layout.vue?vue&type=style&index=0&id=e61fc83a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61fc83a",
  null
  
)

export default component.exports